import { c as _c } from "react/compiler-runtime";
import { Save01Icon } from '@systemeio/icons';
import { ContactFieldValueInterface, ContactSlugEnum } from '@systemeio/types';
import { BadRequest } from '@systemeio/util';
import { ManageFieldsEditErrorResponseInterface, ManageFieldsInterface } from 'modules/contacts/components/update-fields-modal/types/manage-fields-interface';
import UpdateFieldsModalSkeleton from 'modules/contacts/components/update-fields-modal/update-fields-modal-skeleton';
import React, { useEffect } from 'react';
import { Button, FormInput, FormInputPhone, Modal, toast } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { KeyedMutator } from 'swr';
interface UpdateFieldsModalProps {
  opened: boolean;
  data: ManageFieldsInterface | undefined;
  onClose: () => void;
  title: string;
  isLoadingFields: boolean;
  isFetching: boolean;
  updateFields: (data: ManageFieldsInterface) => Promise<void>;
  mutate: KeyedMutator<ManageFieldsInterface>;
  unusedFields?: (data: ManageFieldsInterface | undefined) => undefined | {
    id: number;
    fieldValues: ContactFieldValueInterface[];
  };
}
function UpdateFieldsModal(t0) {
  const $ = _c(33);
  const {
    opened,
    onClose,
    isLoadingFields,
    isFetching,
    title,
    updateFields,
    mutate,
    data,
    unusedFields
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [tempState, setTempState] = React.useState();
  const [errors, setErrors] = React.useState();
  let t1;
  if ($[0] !== data || $[1] !== unusedFields) {
    t1 = () => {
      if (data && unusedFields) {
        setTempState(unusedFields(data));
      }
    };
    $[0] = data;
    $[1] = unusedFields;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== data) {
    t2 = [data];
    $[3] = data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function onChangeField(value, index) {
      setTempState(prev => {
        if (!prev) {
          return prev;
        }
        const updatedFieldValues = [...prev.fieldValues];
        const currentField = updatedFieldValues[index];
        if (currentField) {
          updatedFieldValues[index] = {
            ...currentField,
            value
          };
        }
        return {
          ...prev,
          fieldValues: updatedFieldValues
        };
      });
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onChangeField = t3;
  let t4;
  if ($[6] !== mutate || $[7] !== onClose || $[8] !== t || $[9] !== tempState || $[10] !== updateFields) {
    t4 = async function onSubmit() {
      ;
      try {
        if (tempState) {
          setErrors(undefined);
          await updateFields(tempState);
          await mutate(tempState);
          onClose();
          toast.success(t("global.changes_saved"));
        }
      } catch (t5) {
        const error = t5;
        if (error instanceof BadRequest) {
          setErrors(error.errors);
        } else {
          toast.error(t("global.error"));
        }
      }
    };
    $[6] = mutate;
    $[7] = onClose;
    $[8] = t;
    $[9] = tempState;
    $[10] = updateFields;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const onSubmit = t4;
  let t5;
  if ($[12] !== errors?.fields?.fields || $[13] !== isLoadingFields || $[14] !== tempState?.fieldValues) {
    t5 = isLoadingFields ? <UpdateFieldsModalSkeleton /> : tempState?.fieldValues.map((item, index_0) => {
      const key = `${item.contactField.slug}-${index_0}`;
      const label = item.contactField.fieldName;
      const value_0 = item.value || "";
      const error_0 = errors?.fields?.fields[item.contactField.slug]?.join("\n");
      return item.contactField.slug === ContactSlugEnum.PhoneNumber ? <FormInputPhone key={key} label={label} value={value_0} onChange={phone => onChangeField(phone, index_0)} error={error_0} /> : <FormInput key={key} label={label} value={value_0} onChange={e => onChangeField(e.target.value, index_0)} error={error_0} />;
    });
    $[12] = errors?.fields?.fields;
    $[13] = isLoadingFields;
    $[14] = tempState?.fieldValues;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const t6 = isFetching || isLoadingFields;
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Save01Icon />;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("global.save");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== isFetching || $[20] !== onSubmit || $[21] !== t6 || $[22] !== t8) {
    t9 = <Button className="tablet:self-end self-stretch" disabled={isFetching} onClick={onSubmit} isLoading={t6} variant="primary" size="md">{t7}{t8}</Button>;
    $[19] = isFetching;
    $[20] = onSubmit;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t5 || $[25] !== t9) {
    t10 = <div className="flex flex-col gap-5">{t5}{t9}</div>;
    $[24] = t5;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== isFetching || $[28] !== onClose || $[29] !== opened || $[30] !== t10 || $[31] !== title) {
    t11 = <Modal opened={opened} onClose={onClose} title={title} isFetching={isFetching}>{t10}</Modal>;
    $[27] = isFetching;
    $[28] = onClose;
    $[29] = opened;
    $[30] = t10;
    $[31] = title;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
}
export default UpdateFieldsModal;